import { render, staticRenderFns } from "./preview-component-critical-tasks-assessment.vue?vue&type=template&id=772fb134&"
import script from "./preview-component-critical-tasks-assessment.vue?vue&type=script&lang=js&"
export * from "./preview-component-critical-tasks-assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports